import { useSortable } from "@dnd-kit/sortable";
import { SelectedProductRow } from "../SelectedProductRow/SelectedProductRow";
import { Box, IconButton, useTheme } from "@mui/material";
import { Product } from "orval/generated/models";
import { CustomIcon, Icons } from "components/common/CustomIcon";

interface SortableItemProps {
  id: string;
  item: Product;
  selectedProducts: Product[];
  handleRemoveSelectedProduct: (guid: string) => void;
  overlay?: boolean;
}

export function SortableItem(props: SortableItemProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({
    id: props.id,
  });
  const { palette } = useTheme();

  return (
    <Box
      ref={setNodeRef}
      display={"flex"}
      flexDirection={"row"}
      sx={{
        display: "flex",
        border: `solid 0.5px #6A6A6A`,
        borderRadius: 1,
        marginBottom: 1,
        marginRight: 1.25,
        padding: 0.5,
        backgroundColor: "white",
        opacity: isDragging && props.overlay === false ? 0.3 : undefined,
        alignItems: "center",
      }}
    >
      <Box width={"10%"}>
        <IconButton
          aria-label="drag"
          sx={{ marginRight: 1 }}
          {...attributes}
          {...listeners}
        >
          <CustomIcon
            name={Icons.MOVE}
            width={24}
            height={24}
            fill={palette.text.primary}
          />
        </IconButton>
      </Box>
      <SelectedProductRow
        item={props.item}
        handleRemoveSelectedProduct={props.handleRemoveSelectedProduct}
      />
    </Box>
  );
}
